export default {
    VALIDATION: 'validation',
    PASSWORD: 'password',
    SERVER_VALIDATION: 'serverValidation',
    NETWORK_ERROR: 'networkError',
    EXPIRED_USER: 'membership_expired',
};
